import React, { Component } from 'react';
import { debounce } from 'lodash';

import { addTranslation, IntlProps } from 'decorators/addTranslation';
import PageTemplate from 'components/pageTemplate';
import Loader from 'components/ui/loader';
import HelpMenu from './components/menu';
// import HelpSearch from './components/search';
import HelpArticle from 'pages/help/article';
// import HelpSearchResults from 'pages/help/searchResults';
import AnchorList from './components/ancorList';
import './helpPage.scss';

interface Props extends IntlProps {
  // isSearchResults: boolean;
  isFetched: boolean;
}
interface State {
  isSmallScreen: boolean;
}

class HelpPage extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isSmallScreen: false,
    };

    this.computeWidth = debounce(this.computeWidth, 100);
  }

  componentDidMount() {
    this.computeWidth();
    window.addEventListener('resize', this.computeWidth);
  }

  render() {
    const { isFetched, getTranslate } = this.props;

    return (
      <PageTemplate.Main customClass='help-page'>
        {/* <div className='help-page__main'>
          <div className='help-page__header'>
            <HelpSearch />
          </div>
        </div> */}
        <div className='help-page__main'>
          <div className='help-page__sidebar'>
            <HelpMenu showSubmenu={this.state.isSmallScreen} />
          </div>
          <div className='help-page__content'>
            {isFetched ? this.renderContent() : <Loader />}
          </div>
          {!this.state.isSmallScreen && (
            <div className='help-page__sidebar'>
              <div className='help-menu help-menu_anchor-list'>
                <div className='help-menu__header help-menu__title'>
                  {getTranslate('help.contents.title')}
                </div>
                <AnchorList />
              </div>
            </div>
          )}
        </div>
      </PageTemplate.Main>
    );
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.computeWidth);
  }

  renderContent() {
    return <HelpArticle />;
    /* const { isSearchResults } = this.props;
    return isSearchResults ? <HelpSearchResults /> : <HelpArticle />; */
  }

  computeWidth = () => {
    this.setState({ isSmallScreen: document.body.offsetWidth <= 1200 });
  };
}

export default addTranslation(HelpPage);
